"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var React = __importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = __importDefault(require("styled-components"));
var asRendition_1 = __importDefault(require("../../asRendition"));
var utils_1 = require("../../utils");
var Txt_1 = require("../Txt");
var BaseHeading = styled_components_1.default.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-weight: normal;\n\t", "\n\t", ";\n\t", "\n\t", "\n"], ["\n\tfont-weight: normal;\n\t", "\n\t", ";\n\t", "\n\t", "\n"])), Txt_1.align, utils_1.monospace, Txt_1.caps, Txt_1.bold);
BaseHeading.displayName = 'Heading';
var setDefaultProps = recompose_1.withProps(function (props) {
    return Object.assign({
        fontSize: 4,
        m: 0,
        bold: false,
    }, props);
});
var Factory = function (tag) {
    return asRendition_1.default(function (props) {
        return React.createElement(BaseHeading, __assign({ as: tag }, props));
    }, [setDefaultProps]);
};
var Base = Factory();
Base.h1 = Factory('h1');
Base.h1.defaultProps = {
    fontSize: 7,
    m: 0,
};
Base.h2 = Factory('h2');
Base.h2.defaultProps = {
    fontSize: 6,
    m: 0,
};
Base.h3 = Factory('h3');
Base.h3.defaultProps = {
    fontSize: 5,
    m: 0,
};
Base.h4 = Factory('h4');
Base.h4.defaultProps = {
    fontSize: 4,
    m: 0,
    bold: true,
};
Base.h5 = Factory('h5');
Base.h5.defaultProps = {
    fontSize: 3,
    m: 0,
    bold: true,
};
Base.h6 = Factory('h6');
Base.h6.defaultProps = {
    fontSize: 2,
    m: 0,
    bold: true,
};
exports.Heading = Base;
var templateObject_1;
